import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {tap} from 'rxjs/operators';
import {DOMAIN_VALUE_CD_ROLE_OBJECT_TYPE_REGION} from '../../../../../assets/domains/domains';
import {SessionService} from '../../../../services/session.service';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class MandantAdminService
{
  private http = inject(HttpClient);
  private sessionService = inject(SessionService);

  readonly prefix = 'mandant/admin';

  getUsers(): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + this.prefix + '/user';
    console.log('HTTP GET: ' + url);
    return this.http.get<any>(url).pipe(
      tap(data =>
      {
        for (const user of data)
          this.initUser(user);
      })
    );
  }

  getUsersAdditionalInformation(additionalInfoObjectList: string[]): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + this.prefix + '/user?additionalInfoObjectList=' +
      additionalInfoObjectList.join(',');
    console.log('HTTP GET: ' + url);
    return this.http.get<any>(url).pipe(
      tap(data =>
      {
        for (const user of data)
          this.initUser(user);
      })
    );
  }

  getDartsScorerUsers(): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + this.prefix + '/user';
    console.log('HTTP GET: ' + url);
    return this.http.get<any>(url).pipe(
      tap(data =>
      {
        for (const user of data)
        {
          this.initUser(user);
        }
      })
    );
  }

  getUsersForObject(objectName: string, objectName2: string, objectId: number): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + this.prefix + '/user?objectName=' + objectName +
      '&objectId=' + objectId + (objectName2 ? ('&objectName2=' + objectName2) : '');

    console.log('HTTP GET: ' + url);
    return this.http.get<any>(url).pipe(
      tap(data =>
      {
        for (const user of data)
        {
          this.initUser(user);
        }
      })
    );
  }

  private initUser(user: any): void
  {
    if (user.userMandants?.length > 0)
    {
      if (user.userMandants[0].roles?.length > 0)
      {
        user.role = user.userMandants[0].roles[0].name;
        if (user.userMandants[0].roles[0].objectName)
        {
          let objectAssigned: boolean;
          const userMandant = this.getUserMandantObject(user.userMandants[0].userMandantObjects,
            user.userMandants[0].roles[0].objectName);

          objectAssigned = (userMandant?.id > 0) ? true : false;
          if (!objectAssigned && user.role)
            user.role += ' (-)';
        }
      }

      user.showCustomButton = !user.deleted && !user.userDisabled;
      user.customButtonDisabled = !user.mail;

      // Für Filter in generischer Liste
      user.dartsScorerAccount = !!user.dartsScorerAccount;
      user.userDisabled = !!user.userDisabled;

      user.hasRegion = false;
      if (user.userMandants?.length > 0 && user.userMandants[0].userMandantObjects?.length > 0)
      {
        user.hasRegion = user.userMandants[0].userMandantObjects.filter(umo => umo.objectName === DOMAIN_VALUE_CD_ROLE_OBJECT_TYPE_REGION).length > 0;
        user.objectDisplayName = user.userMandants[0].userMandantObjects[0].name;
      }
    }
  }

  public getUserMandantObject(userMandantObjects: any[], objectName: string): any
  {
    if (userMandantObjects && userMandantObjects.length > 0 && objectName)
    {
      for (const userMandantObject of userMandantObjects)
      {
        if (userMandantObject.objectName === objectName)
          return userMandantObject;
      }
    }
    return undefined;
  }

  public getUserMandantObjectId(userMandantObjects: any[], objectName: string): any
  {
    if (userMandantObjects?.length > 0 && objectName)
    {
      for (const userMandantObject of userMandantObjects)
      {
        if (userMandantObject.objectName === objectName && userMandantObject.id > 0)
          return userMandantObject.id;
      }
    }
    return undefined;
  }
  public getUserMandantObjectIds(userMandantObjects: any[], objectName: string): number[]
  {
    if (userMandantObjects?.length > 0 && objectName)
    {
      const numbers = [];
      for (const userMandantObject of userMandantObjects)
      {
        if (userMandantObject.objectName === objectName && userMandantObject.id > 0)
          numbers.push(userMandantObject.id);
      }
      return numbers;
    }
    return [];
  }

  public getUserMandantObjects(userMandantObjects: any[], objectName: string): any
  {
    if (!userMandantObjects)
      return undefined;

    const list = [];
    if (userMandantObjects && userMandantObjects.length > 0 && objectName)
    {
      for (const userMandantObject of userMandantObjects)
      {
        if (userMandantObject.objectName === objectName)
          list.push(userMandantObject);
      }
    }
    return list;
  }
  public getUserMandantObjectsAll(userMandantObjects: any[]): any[]
  {
    if (!userMandantObjects)
      return undefined;

    const list = [];
    if (userMandantObjects && userMandantObjects.length > 0)
    {
      for (const userMandantObject of userMandantObjects)
      {
        if (userMandantObject.objectName)
          list.push(userMandantObject);
      }
    }
    return list;
  }

  saveUser(user: any): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + this.prefix + '/user';
    console.log('HTTP POST: ' + url, user);
    return this.http.post<any>(url, user);
  }

  deleteUser(userId: number): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + this.prefix + '/user/' + userId;
    console.log('HTTP DELETE: ' + url);
    return this.http.delete<any>(url);
  }
  deleteUserAdditionalInformation(userId: number, additionalInfoObject: string): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + this.prefix + '/user/' + userId + '?additionalInfoObject=' +
      additionalInfoObject;
    console.log('HTTP DELETE: ' + url);
    return this.http.delete<any>(url);
  }

  getCreateUserInfos(loadAllRoles: boolean, roleFilterApplyTeams: boolean): Observable<any>
  {
    const filter = new URLSearchParams([]);
    if (loadAllRoles)
      filter.append('loadAllRoles', '1');
    if (roleFilterApplyTeams)
      filter.append('roleFilterApplyTeams', '1');

    const filterStr = filter.toString();
    const url = environment.baseUrlUsermanagement + this.prefix + '/user/infos' + (filterStr ? ('?' + filterStr) : '');
    console.log('HTTP GET: ' + url);
    return this.http.get<any>(url);
  }

  resendUserPassword(userId: number): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + this.prefix + '/user/' + userId + '/sendpassword';
    console.log('HTTP POST: ' + url);
    return this.http.post<any>(url, null);
  }

  public changePassword(password: string, username: string): Observable<any>
  {
    const body = {
      password,
      username
    };
    const url = environment.baseUrlUsermanagement + this.prefix + '/changepassword';
    console.log('HTTP POST: ' + url);
    return this.http.post<any>(url, body);
  }

  public sendMail(mailTo: string): Observable<any>
  {
    const url = environment.baseUrlUsermanagement + 'admin/mail';
    console.log('HTTP POST: ' + url);
    return this.http.post<any>(url, {email: mailTo});
  }

  getReport(reportTypeCd: string, filterBody: any): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + this.prefix + '/report/' + reportTypeCd;
    console.log('HTTP POST: ' + url, filterBody);
    return this.http.post<any>(url, filterBody);
  }

  setTcUserPasswords(): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + 'mandant/admin/user/setTcUserPasswords';
    console.log('HTTP POST: ' + url);
    return this.http.post<any>(url, null);
  }

}
